<div class="modal-header">
  <button type="button" class="close" (click)="onNoClick()">
    <span aria-hidden="true">×</span>
  </button>
</div>
<div class="modal-body" style="display: block; max-height: 88%;">
  <div [innerHTML]="waiver">
  </div>
</div>
<div class="modal-footer justify-content-between" style="padding: 0px;padding-top: 10px;">
  <div class="d-none d-md-block col-md-4">
    <button type="button" class="btn btn-default btn-dialog" (click)="onNoClick()">{{ 'Cancel' | translate }}</button>
  </div>
  <div class="col-12 col-md-4 text-right">
    <button type="button" class="btn btn-primary btn-dialog" (click)="onYesClick()" cdkFocusInitial>{{ 'Accept' | translate }}</button>
  </div>
</div>
